<template>
  <span>
    <md-select v-model="status" name="publicado" id="publicado" v-if="mostra_status">
      <md-option
        v-for="(item,index) in items_status"
        :key="index"
        :value="item.value"
      >{{item.label}}</md-option>
    </md-select>
    <label v-if="!mostra_status">{{getLabelStatus(status)}}</label>
  </span>
</template>
<script>
import service from "../../services/InspecaoService";
export default {
  props: {
    status: {}
  },
  model: {
    prop: "status",
    event: "selected"
  },
  watch: {
    status: function(val) {
      this.$emit("selected", this.status);
    }
  },
  data() {
    return {
      items_status: service.getListStatus(),
      mostra_status: true
    };
  },
  mounted() {
    let self = this;
    this.testShow();
  
  },
  methods: {
    getLabelStatus(valor) {
      return service.getNomeStatus(valor);
    },
    testShow(){
        let user = JSON.parse(window.obj_user.getUser());

        var codigo_perfil = "";

        if ( user.perfil_codigo ){
          codigo_perfil = user.perfil_codigo;
        }
        if (
          user.perfil.toLowerCase().indexOf("administrador") < 0 &&
          user.perfil.toLowerCase().indexOf("supervisor") < 0 &&
          codigo_perfil != "1" &&
            ( (user.perfil.toLowerCase().indexOf("técnico") < 0 || 
                user.perfil.toLowerCase().indexOf("tecnico") < 0 || codigo_perfil == "2" || codigo_perfil == "TEC") && this.status == 1 ) 
        ) {
          this.mostra_status = false;
        }
    }
  }
};
</script>